// src/App.js
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate, Link } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Avisos from "./components/Avisos";
import Home from "./pages/Home";
import Contacto from "./pages/Contacto";
import DeportePage from "./pages/DeportePage";
import AlbumPage from "./pages/AlbumPage";
import Login from "./components/Login";
import ScrollToTop from "./components/ScrollToTop";
import Bio from "./pages/Bio";
import BioManager from "./components/BioManager";
import "./styles/index.css";

// Herramienta interna: se descarga solo al abrirla (no viaja en el sitio público)
const Cotizador = lazy(() => import("./pages/Cotizador"));
const Pagar = lazy(() => import("./pages/Pagar")); // trae la librería de QR solo aquí
const cargando = <div className="state page-top"><div className="spinner" /></div>;

function NoEncontrada() {
    return (
        <div className="state" style={{ minHeight: "80vh" }}>
            <span className="eyebrow">Error 404</span>
            <h1 className="display">Fuera de cuadro</h1>
            <p>Esta página no existe o se movió.</p>
            <Link to="/" className="btn btn-volt">Volver al inicio</Link>
        </div>
    );
}

export default function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <ScrollToTop />
                <Header />

                <main>
                    <Routes>
                        {/* Rutas públicas */}
                        <Route path="/" element={<Home />} />
                        <Route path="/contacto" element={<Contacto />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/bio" element={<Bio />} />
                        <Route path="/deporte/:deporteId" element={<DeportePage />} />
                        <Route path="/album/:albumId" element={<AlbumPage />} />
                        <Route path="/pagar" element={<Suspense fallback={cargando}><Pagar /></Suspense>} />

                        {/* Rutas protegidas (admin) */}
                        <Route
                            path="/admin/deporte/:deporteId"
                            element={
                                <ProtectedRoute>
                                    <DeportePage isAdminMode={true} />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin/bio"
                            element={
                                <ProtectedRoute>
                                    <BioManager />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path="/admin/cotizador"
                            element={
                                <ProtectedRoute>
                                    <Suspense fallback={cargando}>
                                        <Cotizador />
                                    </Suspense>
                                </ProtectedRoute>
                            }
                        />

                        {/* Links viejos (antes mostraban "Deporte no encontrado") */}
                        <Route path="/galeria-futbol" element={<Navigate to="/deporte/futbol" replace />} />
                        <Route path="/galeria-basquet" element={<Navigate to="/deporte/basquet" replace />} />
                        <Route path="/galeria-box" element={<Navigate to="/deporte/box" replace />} />

                        <Route path="*" element={<NoEncontrada />} />
                    </Routes>
                </main>
                <Avisos />

                <Footer />
            </AuthProvider>
        </BrowserRouter>
    );
}
